export default __webpack_public_path__ + "static/media/CloseModalIcon.88e06cce.svg";